import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	/**
	 * The Modal root element rendered by MUI v4 Dialog covers the full viewport
	 * (position: fixed, inset: 0, theme z-index) and captures pointer events
	 * even when hideBackdrop is set, blocking interaction with the Inbox behind it.
	 * Disabling pointer events on the root and re-enabling them only on
	 * the paper (the actual dialog content) frees the rest of the screen.
	 */
	modalRoot: {
		pointerEvents: "none"
	},
	paper: {
		margin: theme.spacing(2),
		pointerEvents: "auto"
	},
	paperMinimized: {
		width: 320,
		padding: 0,
		position: "fixed"
	},
	dialogTitleMinimized: {
		padding: theme.spacing(2)
	},
	dialogContentMinimized: {
		padding: "0px 16px",
		paddingBottom: theme.spacing(2)
	},
	avatarMinimized: {
		width: 40,
		height: 40
	},
	dialogTitle: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		cursor: "move"
	},
	dialogTitleActions: {
		display: "flex",
		alignItems: "center",
		top: "8px",
		right: "8px",
		position: "absolute"
	},
	dialogTitleActionIconButton: {
		padding: theme.spacing(1),
		borderRadius: theme.spacing(0.5),
		backgroundColor: colors.gray[50]
	},
	dialogContent: {
		paddingBottom: theme.spacing(3)
	},
	creditBalanceIndicatorContainer: {
		width: "100%"
	},
	avatarContainer: {
		position: "relative"
	},
	"@keyframes pulse": {
		"0%": { transform: "scale(1)", opacity: 0.7 },
		"100%": { transform: "scale(1.35)", opacity: 0 }
	},
	pulseRing: {
		position: "absolute",
		top: -2,
		left: -2,
		right: -2,
		bottom: -2,
		borderRadius: "50%",
		border: `2px solid ${theme.palette.primary.main}`,
		opacity: 0,
		animation: "$pulse 1.6s ease-out infinite"
	},
	avatar: {
		width: 80,
		height: 80
	},
	callStatusCalling: {
		color: theme.palette.primary.main
	},
	callStatusConnected: {
		color: theme.palette.success.main
	},
	timer: {
		fontSize: 32,
		fontWeight: 600,
		letterSpacing: 1,
		fontVariantNumeric: "tabular-nums",
		color: theme.palette.text.primary,
		marginBottom: 8
	},
	dividerContainer: {
		width: "100%"
	},
	fabGreen: {
		width: 56,
		height: 56,
		background: colors.green[600],
		"&:hover": {
			background: colors.green[700]
		},
		"& svg": {
			color: colors.gray[0]
		}
	},
	fabRed: {
		width: 56,
		height: 56,
		background: colors.red[600],
		"&:hover": {
			background: colors.red[700]
		},
		"& svg": {
			color: colors.gray[0]
		}
	}
}))

export default useStyles
